<template>
  <chartComponent></chartComponent>
</template>

<script>
  import chartComponent from '@/views/chart/pages/components/chart_component.vue';

  export default {
    name: "chart_page",
    components: {
      chartComponent,
    },

  };
</script>

<style lang="css" scoped>
</style>